import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';

const { acura_red, black, off_white, mid_grey, white } = appPalette.colors;
type Props = {
  isLight: boolean;
};

function focusableStyles(offset: number) {
  return {
    outline: `0.125rem solid`,
    outlineOffset: `.${offset}rem`,
  };
}

export const useStyles = makeStyles({
  trigger_text: {
    cursor: 'pointer',
    '&:hover': {
      color: acura_red,
    },
  },
  trigger_sup: {
    top: 0,
  },
  trigger_button: {
    cursor: 'pointer',
    '&:hover': {
      color: acura_red,
    },
    '&:focus': {
      'body:not(.acr-focus-disabled) &': {
        ...focusableStyles(2),
        color: acura_red,
        outlineColor: black,
      },
    },
    font: 'inherit',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
  },
  tooltip: {
    backgroundColor: ({ isLight }: Props) => (isLight ? off_white : mid_grey),
    fontSize: '0.875rem',
    maxWidth: '14.25rem',
    padding: '0.875rem',
    '&.medium': {
      maxWidth: '20.625rem',
    },
    '&.large': {
      maxWidth: '26.875rem',
    },
  },
  tooltip_content: {
    color: ({ isLight }: Props) => (isLight ? black : white),
    '& .content a': {
      color: ({ isLight }: Props) => (isLight ? black : white),
      '&:focus': {
        'body:not(.acr-focus-disabled) &': {
          ...focusableStyles(2),
          outlineColor: ({ isLight }: Props) => (isLight ? black : white),
        },
      },
    },
  },
  tooltip_title: {
    color: ({ isLight }) => (isLight ? black : white),
    marginBottom: '0.625rem',
  },
  arrow: {
    color: ({ isLight }) => (isLight ? off_white : mid_grey),
  },
  children_btn: {
    position: 'relative',
    zIndex: '4',
    cursor: 'pointer',
    '&:focus': {
      'body:not(.acr-focus-disabled) &': {
        ...focusableStyles(2),
        color: acura_red,
        outlineColor: black,
      },
    },
    display: 'flex',
  },
});
